<template>
  <div
    :class="[
      $style.base,
      {
        [$style.hasSignupBg]: showSignupBg,
        [$style.smallScreen]: $screen === 's',
        [$style.mediumScreen]: $screen === 'm',
        [$style.treatwell]: config.isTreatwellDomain
      }
    ]"
  >
    <transition>
      <div
        v-if="showSignupBg"
        :class="$style.signupBg"
      />
    </transition>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { useRoute } from 'vue-router';
import config from '@/config';
import { useNativeAppStore } from '@/stores/native-app';

const route = useRoute();
const { isNativeAppIOS } = useNativeAppStore();

const showSignupBg = computed(() => !isNativeAppIOS && route.name === 'signup');
</script>

<style
  lang="scss"
  module
>
.base {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  transition: background-color 0.3s ease;

  @include theme('light') {
    background-color: #aeaee9;

    &.treatwell {
      background-color: var(--color-accent);
      opacity: 0.4;
    }

    &.treatwell:not(.hasSignupBg) {
      opacity: 1;
    }
  }

  @include theme('dark') {
    background-color: var(--color-bg-secondary);
  }

  &.hasSignupBg {
    background-color: black;
  }
}

.signupBg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  filter: blur(5px);

  .base:not(.smallScreen):not(.mediumScreen) & {
    background-image: url('/img/signup/bg-desktop.jpg');
    background-size: 100% auto;
    background-position: center top;
  }

  .base.mediumScreen & {
    background-image: url('/img/signup/bg-tablet.jpg');
    background-size: cover;
    background-position: center center;
  }

  .base.smallScreen & {
    background-image: url('/img/signup/bg-mobile.jpg');
    background-size: cover;
    background-position: center center;
  }

  &:global(.v-enter-active),
  &:global(.v-leave-active) {
    transition: opacity 0.3s ease;
  }

  &:global(.v-enter-from),
  &:global(.v-leave-to) {
    opacity: 0;
  }
}
</style>
